import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
// slices
import authSlice from "./slices/authSlice";
import bannerSlice from "./slices/bannerSlice";
import brandSlice from "./slices/brandSlice";
import categorySlice from "./slices/categorySlice";
import colorSlice from "./slices/colorSlice";
import customerSlice from "./slices/customerSlice";
import dashboardSlice from "./slices/dashboardSlice";
import emergencyContactSlice from "./slices/emergencyContactSlice";
import faqSlice from "./slices/faqSlice";
import offerSlice from "./slices/offerSlice";
import orderSlice from "./slices/orderSlice";
import productSlice from "./slices/productSlice";
import referSlice from "./slices/referSlice";
import roleSlice from "./slices/roleSlice";
import sizeSlice from "./slices/sizeSlice";
import tagSlice from "./slices/tagSlice";
import teamSlice from "./slices/teamSlice";
import userSlice from "./slices/userSlice";
import userTypeSlice from "./slices/userTypeSlice";

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  team: teamSlice,
  role: roleSlice,
  userType: userTypeSlice,
  faq: faqSlice,
  category: categorySlice,
  size: sizeSlice,
  color: colorSlice,
  brand: brandSlice,
  customer: customerSlice,
  product: productSlice,
  setting: referSlice,
  tag: tagSlice,
  order: orderSlice,
  banner: bannerSlice,
  offer: offerSlice,
  emergencyContact: emergencyContactSlice,
  dashboard: dashboardSlice,
});

export default rootReducer;
